import { productUsesCampaignFirstImages } from "@/helpers/collection.js";

export const collectionImageSequence = ["campaignImages"];

export const reccsImageSequence = ["campaignImages"];

export const productImageSequence = [
  "campaignImages",
  "campaignSecondaryImages",
  "campaignVideos",
  "ecomVideos",
  "ecomImages",
  "ecomXLImages",
  "ecomBack",
  "ecomSide",
  "ecomCloseUpImages",
  "flatlayImages",
  "flatlayBack",
  "flatlayReverseFront",
  "flatlayReverseBack",
];

export const indexFeaturedProductsSequence = ["ecomImages"];

export const howToWearImageSequence = ["ecomImages"];

// Get modified product image sequence for A/B testing
export const getProductImageSequence = (
  useAltCampaignImages = false,
  ecomFirstOnPDP = false,
  product = null,
  ecomXLOnPDP = false
) => {
  let baseSequence;

  if (useAltCampaignImages) {
    // When using alt campaign images, try alt first, then fallback to normal campaign + secondary
    baseSequence = [
      "altCampaignImages",
      "campaignImages", // Fallback if alt doesn't exist
      "campaignSecondaryImages", // Keep secondary, will be conditionally skipped if alt is used
      "campaignVideos",
      "ecomVideos",
      "ecomImages",
      "ecomXLImages",
      "ecomBack",
      "ecomSide",
      "ecomCloseUpImages",
      "flatlayImages",
      "flatlayBack",
      "flatlayReverseFront",
      "flatlayReverseBack",
    ];
  } else {
    baseSequence = [...productImageSequence];
  }

  if (!ecomXLOnPDP) {
    baseSequence = baseSequence.filter(
      (sequence) => sequence !== "ecomXLImages"
    );
  }

  const useEcomFirstOnPDP =
    ecomFirstOnPDP && !productUsesCampaignFirstImages(product);

  if (useEcomFirstOnPDP) {
    const ecomFirstOrder = [
      "ecomImages",
      "ecomXLImages",
      "ecomBack",
      "ecomSide",
      "ecomCloseUpImages",
      "ecomVideos",
    ].filter((sequence) => (ecomXLOnPDP ? true : sequence !== "ecomXLImages"));

    return [
      ...ecomFirstOrder.filter((s) => baseSequence.includes(s)),
      ...baseSequence.filter((s) => !ecomFirstOrder.includes(s)),
    ];
  }

  return baseSequence;
};
